import { Team, DistributionHistory } from '../types'

export const MOCK_TEAMS: Team[] = [
  {
    id: 't1',
    name: 'Purchase',
    campaignName: 'New Purchase Nurture',
    campaignId: 'cmp_purchase_01',
    distributionMethod: 'round-robin',
    color: 'blue',
    active: true,
    totalLeadsDistributed: 1245,
    users: [
      {
        id: 'u1',
        name: 'Sarah Miller',
        email: 'sarah@apexmortgage.com',
        bonzoOwnerId: 'bz_sm_01',
        weight: 100,
        leadsAssigned: 450,
        active: true,
      },
      {
        id: 'u2',
        name: 'Mike Johnson',
        email: 'mike@apexmortgage.com',
        bonzoOwnerId: 'bz_mj_02',
        weight: 100,
        leadsAssigned: 412,
        active: true,
      },
      {
        id: 'u3',
        name: 'Jessica Davis',
        email: 'jess@apexmortgage.com',
        bonzoOwnerId: 'bz_jd_03',
        weight: 100,
        leadsAssigned: 383,
        active: true,
      },
    ],
  },
  {
    id: 't2',
    name: 'Refinance',
    campaignName: 'Refi Rate Alert Drip',
    campaignId: 'cmp_refi_02',
    distributionMethod: 'weighted',
    color: 'emerald',
    active: true,
    totalLeadsDistributed: 850,
    users: [
      {
        id: 'u4',
        name: 'David Wilson',
        email: 'david@apexmortgage.com',
        bonzoOwnerId: 'bz_dw_04',
        weight: 60,
        leadsAssigned: 510,
        active: true,
      },
      {
        id: 'u5',
        name: 'Emma Brown',
        email: 'emma@apexmortgage.com',
        bonzoOwnerId: 'bz_eb_05',
        weight: 40,
        leadsAssigned: 340,
        active: true,
      },
    ],
  },
  {
    id: 't3',
    name: 'FHA / VA',
    campaignName: 'FHA/VA Welcome Sequence',
    campaignId: 'cmp_fhava_03',
    distributionMethod: 'round-robin',
    color: 'amber',
    active: true,
    totalLeadsDistributed: 620,
    users: [
      {
        id: 'u6',
        name: 'James Taylor',
        email: 'james@apexmortgage.com',
        bonzoOwnerId: 'bz_jt_06',
        weight: 100,
        leadsAssigned: 210,
        active: true,
      },
      {
        id: 'u7',
        name: 'Linda Anderson',
        email: 'linda@apexmortgage.com',
        bonzoOwnerId: 'bz_la_07',
        weight: 100,
        leadsAssigned: 205,
        active: true,
      },
      {
        id: 'u8',
        name: 'Robert Martin',
        email: 'robert@apexmortgage.com',
        bonzoOwnerId: 'bz_rm_08',
        weight: 100,
        leadsAssigned: 205,
        active: true,
      },
    ],
  },
  {
    id: 't4',
    name: 'Home Equity',
    campaignName: 'HELOC Outreach',
    campaignId: 'cmp_heloc_04',
    distributionMethod: 'weighted',
    color: 'purple',
    active: false,
    totalLeadsDistributed: 150,
    users: [
      {
        id: 'u9',
        name: 'Patricia White',
        email: 'pat@apexmortgage.com',
        bonzoOwnerId: 'bz_pw_09',
        weight: 80,
        leadsAssigned: 120,
        active: true,
      },
      {
        id: 'u10',
        name: 'Thomas Harris',
        email: 'tom@apexmortgage.com',
        bonzoOwnerId: 'bz_th_10',
        weight: 20,
        leadsAssigned: 30,
        active: true,
      },
    ],
  },
]

export const MOCK_HISTORY: DistributionHistory[] = [
  {
    id: 'h1',
    date: '2025-02-10T10:30:00',
    fileName: 'zillow_purchase_leads_feb.csv',
    totalLeads: 245,
    teamsInvolved: ['Purchase', 'FHA / VA'],
    status: 'completed',
    breakdown: [
      { teamId: 't1', teamName: 'Purchase', count: 145 },
      { teamId: 't3', teamName: 'FHA / VA', count: 100 },
    ],
  },
  {
    id: 'h2',
    date: '2025-02-08T14:15:00',
    fileName: 'refi_rate_drop_prospects.csv',
    totalLeads: 120,
    teamsInvolved: ['Refinance'],
    status: 'completed',
    breakdown: [{ teamId: 't2', teamName: 'Refinance', count: 120 }],
  },
  {
    id: 'h3',
    date: '2025-02-05T09:00:00',
    fileName: 'lending_tree_mixed_leads.csv',
    totalLeads: 500,
    teamsInvolved: ['Purchase', 'Refinance', 'FHA / VA'],
    status: 'partial',
    breakdown: [
      { teamId: 't1', teamName: 'Purchase', count: 200 },
      { teamId: 't2', teamName: 'Refinance', count: 150 },
      { teamId: 't3', teamName: 'FHA / VA', count: 100 },
    ],
  },
  {
    id: 'h4',
    date: '2025-02-03T16:45:00',
    fileName: 'bad_format_bankrate.csv',
    totalLeads: 0,
    teamsInvolved: [],
    status: 'failed',
    breakdown: [],
  },
  {
    id: 'h5',
    date: '2025-01-30T11:20:00',
    fileName: 'sf_first_time_buyers_jan.csv',
    totalLeads: 310,
    teamsInvolved: ['Purchase'],
    status: 'completed',
    breakdown: [{ teamId: 't1', teamName: 'Purchase', count: 310 }],
  },
  {
    id: 'h6',
    date: '2025-01-27T08:45:00',
    fileName: 'va_eligible_leads_q1.csv',
    totalLeads: 175,
    teamsInvolved: ['FHA / VA'],
    status: 'completed',
    breakdown: [{ teamId: 't3', teamName: 'FHA / VA', count: 175 }],
  },
  {
    id: 'h7',
    date: '2025-01-22T13:10:00',
    fileName: 'heloc_equity_prospects.csv',
    totalLeads: 90,
    teamsInvolved: ['Home Equity'],
    status: 'completed',
    breakdown: [{ teamId: 't4', teamName: 'Home Equity', count: 90 }],
  },
  {
    id: 'h8',
    date: '2025-01-18T10:00:00',
    fileName: 'realtor_referral_batch.csv',
    totalLeads: 420,
    teamsInvolved: ['Purchase', 'Refinance'],
    status: 'completed',
    breakdown: [
      { teamId: 't1', teamName: 'Purchase', count: 280 },
      { teamId: 't2', teamName: 'Refinance', count: 140 },
    ],
  },
]
